export const USE_LOCALPROVIDER = 'USE_LOCAL';

export interface DateFormatProps {
  short: string;
  shortTime: string;
}

export const dateFormatEn: DateFormatProps = {
  short: 'MMM D, YYYY',
  shortTime: 'MMM D, YYYY h:mm A',
};
